export default {
  SHIPPED: 'Shipped',
  CANCELED: 'Canceled',
  IN_SHIPMENT: 'In Shipment',
  PROCESSING: 'Processing',
  READY_FOR_SHIPMENT: 'Ready For Shipment',
  SPLIT: 'Split',
  TRANSFERRED: 'Transferred',
  // POM-6180 / POM-6217: the line item half of a Fill Later move - the order is parked and each
  // of its line items goes to this processing state. Without the label the Item Status cell and
  // its filter chip render blank. POM-TBD renamed it from VOID.
  FILL_LATER: 'Fill Later',
};
